module.exports = __webpack_public_path__ + "static/media/nitrum-logo.9427f80e.svg";